(function () {
  let form = document.getElementById('FacetFiltersForm');
  let sortSelect = document.querySelector('[data-sort-select]');
  let controller = null;

  function buildUrl() {
    const url = new URL(form ? form.action : window.location.href);

    for (const key of [...url.searchParams.keys()]) {
      if (key.startsWith('filter.')) url.searchParams.delete(key);
    }
    url.searchParams.delete('sort_by');
    url.searchParams.delete('page');

    if (form) {
      form.querySelectorAll('[data-filter-input][type="checkbox"]:checked').forEach(i => {
        url.searchParams.append(i.name, i.value);
      });
      form.querySelectorAll('[data-filter-input][type="number"]').forEach(i => {
        if (i.value) url.searchParams.set(i.name, i.value);
      });
    }

    const sort = sortSelect
      ? sortSelect.value
      : new URL(window.location.href).searchParams.get('sort_by');
    if (sort) url.searchParams.set('sort_by', sort);

    return url.toString();
  }

  function navigate(url, updateFilters, scrollToStart) {
    history.pushState(null, '', url);
    load(url, updateFilters, scrollToStart);
  }

  // Paging swaps the grid in place, so without this the shopper is left at the
  // bottom of the page staring at the pagination of a grid that changed above
  // them. Filter changes deliberately don't scroll — the controls the shopper
  // is using are on screen and moving the page under them would be worse.
  function scrollToSectionStart() {
    const section = document.querySelector('.collection-main');
    if (!section) return;

    // The header is sticky when the merchant enables it, so land below it
    // rather than tucking the top of the section underneath.
    const header = document.querySelector('.site-header');
    const stuck = header && getComputedStyle(header).position === 'sticky';
    const offset = stuck ? header.getBoundingClientRect().height : 0;
    const top = section.getBoundingClientRect().top + window.scrollY - offset - 8;

    // No explicit `behavior`: 'auto' resolves to the CSS scroll-behavior, and
    // app.scss only sets `smooth` under prefers-reduced-motion: no-preference.
    window.scrollTo({ top: Math.max(0, top) });
  }

  function setFilterSpinner(isLoading) {
    const spinner = document.querySelector('[data-filter-spinner]');
    if (spinner) spinner.hidden = !isLoading;
  }

  function load(url, updateFilters, scrollToStart) {
    if (controller) controller.abort();
    controller = new AbortController();

    const results = document.getElementById('collection-results');
    if (results) { results.style.opacity = '0.4'; results.style.pointerEvents = 'none'; }
    setFilterSpinner(true);

    fetch(url, { signal: controller.signal })
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        swapInner('collection-results', doc);
        swapInner('product-count', doc);
        swapInner('active-filters', doc);
        syncCanonical(doc);
        window.__waRenderV12GridBadges?.();

        if (updateFilters) {
          const f = document.getElementById('FacetFiltersForm');
          const nf = doc.getElementById('FacetFiltersForm');
          if (f && nf) {
            f.innerHTML = nf.innerHTML;
            initInputListeners();
          }

          // Sync sort select value to loaded URL
          const loadedSort = new URL(url).searchParams.get('sort_by');
          if (sortSelect && loadedSort) sortSelect.value = loadedSort;
        } else {
          // Don't replace the form (would collapse any open accordion group),
          // but counts and 0-result disabled state still depend on the newly
          // applied combination of filters, so patch them in place.
          updateFilterCounts(doc);
        }

        const r = document.getElementById('collection-results');
        if (r) { r.style.opacity = '1'; r.style.pointerEvents = ''; }
        setFilterSpinner(false);

        // After the swap, so the new grid's height is what we measure against.
        if (scrollToStart) requestAnimationFrame(scrollToSectionStart);
      })
      .catch(e => {
        if (e.name !== 'AbortError') {
          const r = document.getElementById('collection-results');
          if (r) { r.style.opacity = '1'; r.style.pointerEvents = ''; }
          setFilterSpinner(false);
        }
      });
  }

  // Paging and filtering never reload the document, so the canonical link in
  // <head> would keep pointing at whichever page was server-rendered. The
  // fetched document already carries the right one for this URL, so adopt it
  // rather than rebuilding the URL here and risking drift from the Liquid.
  // Read via getAttribute: a DOMParser document has no base URL, so .href on
  // its nodes can't be trusted to resolve.
  function syncCanonical(doc) {
    const live = document.querySelector('link[rel="canonical"]');
    const fresh = doc.querySelector('link[rel="canonical"]');
    if (!live || !fresh) return;

    const href = fresh.getAttribute('href');
    if (href) live.setAttribute('href', href);
  }

  function swapInner(id, doc) {
    const el = document.getElementById(id);
    const nel = doc.getElementById(id);
    if (el && nel) el.innerHTML = nel.innerHTML;
  }

  function updateFilterCounts(doc) {
    const f = document.getElementById('FacetFiltersForm');
    if (!f) return;

    doc.querySelectorAll('[data-filter-input][type="checkbox"]').forEach(freshInput => {
      const liveInput = f.querySelector(
        `[data-filter-input][type="checkbox"][name="${CSS.escape(freshInput.name)}"][value="${CSS.escape(freshInput.value)}"]`
      );
      if (!liveInput || liveInput.checked) return; // never disable/relabel an already-active filter

      const liveLabel = liveInput.closest('.collection-filter__label');
      const liveCount = liveLabel ? liveLabel.querySelector('.collection-filter__count') : null;
      const freshCount = freshInput.closest('.collection-filter__label')?.querySelector('.collection-filter__count');

      if (liveCount && freshCount) liveCount.textContent = freshCount.textContent;

      const isDisabled = freshInput.getAttribute('aria-disabled') === 'true';
      if (isDisabled) liveInput.setAttribute('aria-disabled', 'true');
      else liveInput.removeAttribute('aria-disabled');
      if (liveLabel) liveLabel.classList.toggle('is-disabled', isDisabled);
    });

    syncExhaustedGroups(f);
  }

  // A group whose every value is now 0-result gets dimmed (see .is-exhausted).
  // Recomputed from the live inputs so it stays right after an in-place patch.
  function syncExhaustedGroups(root) {
    root.querySelectorAll('.collection-filter').forEach(group => {
      const inputs = group.querySelectorAll('[data-filter-input][type="checkbox"]');
      if (!inputs.length) return; // price range and other non-list filters
      const exhausted = [...inputs].every(i => i.getAttribute('aria-disabled') === 'true');
      group.classList.toggle('is-exhausted', exhausted);
    });
  }

  function initInputListeners() {
    const f = document.getElementById('FacetFiltersForm');
    if (!f) return;

    f.querySelectorAll('[data-filter-input][type="checkbox"]').forEach(input => {
      const clone = input.cloneNode(true);
      input.parentNode.replaceChild(clone, input);

      // 0-result options are aria-disabled rather than disabled, so they stay in
      // the tab order and remain discoverable. Cancelling the click cancels the
      // check itself (and so the change event) for pointer and Space alike.
      clone.addEventListener('click', e => {
        if (clone.getAttribute('aria-disabled') === 'true') {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      });

      clone.addEventListener('change', e => {
        e.stopImmediatePropagation();
        const label = clone.closest('.collection-filter__label');
        if (label) label.classList.toggle('is-active', clone.checked);
        navigate(buildUrl(), false);
      });
    });

    let priceDebounce;
    f.querySelectorAll('[data-filter-input][type="number"]').forEach(input => {
      const clone = input.cloneNode(true);
      input.parentNode.replaceChild(clone, input);
      clone.addEventListener('input', e => {
        e.stopImmediatePropagation();
        clearTimeout(priceDebounce);
        priceDebounce = setTimeout(() => navigate(buildUrl(), false), 500);
      });
    });
  }

  // Init
  initInputListeners();

  if (form) {
    form.addEventListener('submit', e => {
      e.preventDefault();
      e.stopImmediatePropagation();
      navigate(buildUrl(), false);
    });
  }

  if (sortSelect) {
    const clone = sortSelect.cloneNode(true);
    sortSelect.parentNode.replaceChild(clone, sortSelect);
    sortSelect = clone;
    clone.addEventListener('change', e => {
      e.stopImmediatePropagation();
      navigate(buildUrl(), false);
    });
  }

  // AJAX for pagination, active-filter tag removal, clear-all
  document.addEventListener('click', e => {
    const link = e.target.closest(
      '#product-pagination a, .active-filters__tag, .active-filters__clear, .collection-filters__clear'
    );
    if (!link || !link.href) return;
    e.preventDefault();
    navigate(link.href, true, !!e.target.closest('#product-pagination'));
  });

  window.addEventListener('popstate', () => load(window.location.href, true));
})();
